import React from 'react';

export const TabKeyIdentifierPrefix = 'tabItem_';

/*Key must be specified for tab to render - see examples.
  Id, Text are used by TabPanel for Construction */
export const Tab: React.FC<{
    id: string;
    text: string;
    disabled?: boolean;
    children?: any;
}> = ({ id, text, disabled = false, children }) => {
    const setStyle = {
        cursor: `${disabled ? 'auto' : 'pointer'}`,
    };

    return <div style={setStyle}>{children}</div>;
};
